import React from 'react';
import AnonymousChatApp from './AnonymousChatApp';

const Index = () => {
  return <AnonymousChatApp />;
};

export default Index;